<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-paraa"><a id="page_ii"></a><span class="smallcaps">ALSO BY STEVE DUNO</span></p>
<p class="center-para"><em>Choosing a Dog</em></p>
<p class="center-para"><em>Leader of the Pack</em></p>
<p class="center-para"><em>Show Biz Tricks for Cats</em></p>
<p class="center-para"><em>The Everything Cat Book</em></p>
<p class="center-para"><em>Anti-Aging for Dogs</em></p>
<p class="center-para"><em>Plump Pups and Fat Cats</em></p>
<p class="center-para"><em>Caddie Sense</em></p>
<p class="center-para"><em>Bad Dog!</em></p>
<p class="center-para"><em>No Kitty!</em></p>
<p class="center-para"><em>The K.I.S.S. Guide to Playing Golf</em></p>
<p class="center-para"><em>The K.I.S.S. Guide to Cats</em></p>
<p class="center-para"><em>Every Dog’s Guide to Living with a Neurotic Owner</em></p>
<p class="center-para"><em>The Only Cat Book You’ll Ever Need</em></p>
<p class="center-para"><em>The Clever Cat Trick Kit Book</em></p>
<p class="center-para"><em>The Amazing Dog Trick Kit Book</em></p>
<p class="center-para"><em>Be the Dog: Secrets of the Natural Dog Owner</em></p>
<p class="center-para"><em>Be the Cat: Secrets of the Natural Cat Owner</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmattera.vue?1b7058be